import { render, staticRenderFns } from "./StatementList.vue?vue&type=template&id=b41a98ae&scoped=true"
import script from "./StatementList.vue?vue&type=script&lang=ts"
export * from "./StatementList.vue?vue&type=script&lang=ts"
import style0 from "./StatementList.vue?vue&type=style&index=0&id=b41a98ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41a98ae",
  null
  
)

export default component.exports